import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';

/**
 * Story 3.2: besluit nemen (goedkeuren/afwijzen). Optimistic update naar
 * 'Goedgekeurd'/'Afgewezen' via een direct refetch (invalidateQueries) — de
 * lijst wisselt zichtbaar naar de nieuwe status zodra de server antwoordt,
 * consistent met de bestaande withdraw/submit-hooks (geen client-side
 * cache-mutatie, gewoon een verse fetch; de wachtrij is klein genoeg voor
 * MVP-schaal dat dit geen waarneembare vertraging geeft).
 */
export function useDecideLeaveRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, decision, reason }: { id: number; decision: 'approve' | 'reject'; reason?: string }) =>
      verlofApi.decide(id, decision, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
    },
  });
}
